import cn from "classnames";
import AdvantageCard from "./components/advantageCard/AdvantageCard";
import React, { FC } from "react";
import st from './advantages.module.scss';
import { advantages } from "@pages/partners/items/uralchem/static/sectionsData";

interface AdvantagesProps {
    className: string
}

const Advantages: FC<AdvantagesProps> = ({className}) => {
    return (
        <section className={cn(className, st['advantages'])}>
            {advantages.map((advantage, index) => {
                const number = String(index + 1).padStart(2, '0');
                return <AdvantageCard number={number} text={advantage} filled={index % 2 === 0}/>;
            })}
        </section>
    );
};

export default Advantages;